// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quickGlanceOverlayCss_qtif19v{min-width:120px;background:var(--gray00);z-index:2;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/quick-glance-overlay/QuickGlanceOverlay.css"],"names":[],"mappings":"AAAA,+BAA+B,eAAe,CAAC,wBAAwB,CAAC,SAAS,CAAC","sourcesContent":[".quickGlanceOverlayCss_qtif19v{min-width:120px;background:var(--gray00);z-index:2;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
